
import React, { useState } from 'react';
import "./Forms.scss";
import Dropzone from 'react-dropzone'
import { useDispatch, useSelector } from 'react-redux';
import { setUploadFiles, setCustomerAttachmentId } from '../../redux-files/actions/action';
import fetchApiData from '../../apiHandlers/fetchApiData';
import CONSTANTS from '../../Constants';
import { pushEventToGTM } from '../../helpers/trackerManager';

const Attachments = (props) => {

    const UploadFiles = useSelector(state => state.ndel_store.UploadFiles)
    const customerAttachmentId = useSelector(state => state.ndel_store.customerAttachmentId)
    const [showFormErrors, setShowFormErrors] = useState(false)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()

    const validateAttachmentFile = (file) => {
        let fileList = UploadFiles
        let attachmentId = customerAttachmentId
        //let attachmentUrl = this.props.store.customerAttachmentUrl || []
        const fileService = new fetchApiData();

        const formData = new FormData();
        formData.append('file', file);

        fileService.postSendFile(formData).then(
            res => {
                switch (res.errorCode) {
                    case 0:
                        file.attachementUrl = res.encodedUrl
                        fileList.push(file)
                        dispatch(setUploadFiles(fileList))
                        if (attachmentId === "") {
                            dispatch(setCustomerAttachmentId(res.customerAttachmentId))
                        }

                        // attachmentUrl.push(res.encodedUrl)
                        setIsLoading(false)
                        setShowFormErrors(false)
                        break

                    default:
                        setIsLoading(false)
                        setShowFormErrors(true)
                        setErrorMsg(res.message)
                        break
                }
            },
            error => {
                setIsLoading(false)
                setShowFormErrors(true)
                setErrorMsg(error.message)
            }
        )
    }
    const removeFile = file => {
        let fileList = UploadFiles
        const removeFileService = new fetchApiData();
        removeFileService.DeleteAttachment(file.attachementUrl).then(
            res => {
                if (res.d.status === 'OK') {
                    const newFiles = [...fileList]; // make a var for the new array
                    newFiles.splice(newFiles.indexOf(file), 1); // remove the file from the array
                    dispatch(setUploadFiles(newFiles))
                }
            },
            error => {
                setIsLoading(false)
                setShowFormErrors(true)
                setErrorMsg(error.message)
            }
        )
    }

    const isLoadingclass = (isLoading ? " isLoading" : "");
    return (
        <>
            <div className={`form-wrapper ${props.classes}`}>
                <Dropzone onDrop={acceptedFiles => {
                    if (acceptedFiles.length > 3) {
                        setShowFormErrors(true);
                        setErrorMsg("Un client ne peut uploadé que 3 pièces jointes max.");
                    } else {
                        acceptedFiles.forEach((file) => {
                            setShowFormErrors(false);

                            const reader = new FileReader()

                            reader.onabort = () => { console.log('file reading was aborted') }
                            reader.onerror = () => { console.log('file reading has failed') }
                            reader.onload = () => {
                                setIsLoading(true)
                                validateAttachmentFile(file)
                            }
                            reader.readAsArrayBuffer(file)
                        })
                    }

                }}>
                    {({ getRootProps, getInputProps }) => (
                        <div onClick={() => {
                            pushEventToGTM({
                                pageName: 'personnal info',
                                eventAction: 'Display::Popin::Attachment',
                                eventLabel: CONSTANTS.LABELS.needs_attachment_cta2,
                                eventCategory: 'Content'
                            })
                        }}>
                            <div {...getRootProps()} className={"services-attachments__block" + isLoadingclass}>
                                <input {...getInputProps()} />
                                {<span>{CONSTANTS.LABELS.needs_attachment_cta1}</span>}
                                <div className="services-attachments__button">
                                    <label className="label-file">{CONSTANTS.LABELS.needs_attachment_cta2}</label>
                                </div>
                            </div>

                            {
                                <>

                                    {
                                        UploadFiles.length > 0 &&
                                        <div className="services-attachments__files">
                                            {
                                                Object.values(UploadFiles).map((file, key) => {
                                                    return <span key={key}>{file.path}<i onClick={() => removeFile(file)} className='mark-icons delete-icon' /></span>
                                                })
                                            }
                                        </div>
                                    }


                                </>
                            }

                        </div>
                    )}
                </Dropzone>
            </div>

            {showFormErrors && <div className="section-form"><span className="input-errorLabel">{ErrorMsg}</span></div>}
        </>
    );
}
export default Attachments;